import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Modal, ModalBody} from 'reactstrap';
import FormBuilder from '../../../ui/components/Form/FormBuilder';
import {connect} from 'react-redux';
import {folder, group} from '../../redux';
import LoaderWidget from '../../../ui/components/Loader';
import {useTranslation, withTranslation} from "react-i18next";
import {getPermissions} from '../../../../shared/configUtils';
import {equals, includes, isNil, map} from 'ramda';
import {formatDate, lookupInputValue} from "../../../ui/components/AppMenu/redux/utils";

export const covertFolderToTreeNode = folder => {
    let node = {
        key: folder.resource_id,
        title: folder.label,
        isLeaf: isNil(folder.children),
    };

    if (folder.children && folder.children.length > 0) {
        node.children = folder.children.map(covertFolderToTreeNode);
    }

    return node;
};


const AddGroupComponent = props => {
    const {t} = useTranslation();
    const initialState = {
        inputs: [
            {
                type: 'input',
                name: 'name',
                label: t('groups.form.name'),
                placeholder: t('groups.form.name_placeholder'),
                validations: {
                    required: 'Group name is required'
                }
            },
            {
                type: 'textarea',
                name: 'description',
                label: t('groups.form.description'),
                placeholder: t('groups.form.description_placeholder'),
            },
            {
                type: 'tree',
                name: 'folders',
                label: t('groups.form.folder'),
                placeholder: t('groups.form.folder_placeholder'),
                treeData: {},
            },
            // {
            //     type: 'checkbox',
            //     name: 'is_active',
            //     value: false,
            //     label: t('users.form.status_placeholder'),
            // },
            {
                type: 'dropdown',
                name: 'permission',
                label: 'Permissions',
                placeholder: '',
                multiple: true,
                options: getPermissions().map(p => ({label: p.value, value: p.key})),
                validations: {
                    validations: 'Permissions is required'
                },
            },
        ],
        submitButton: 'Save'
    };

    const [groupState, setGroupState] = useState({...initialState});
    const {data, entities, loading} = props;

    const folders = useMemo(_ => {
        return entities.map(covertFolderToTreeNode);
    }, [entities]);

    useEffect(_ => {
        props.listFolders();
    }, []);

    useEffect(_ => {
        const inputs = groupState.inputs.map(i => {

            const input = {...i};

            if (data) {
                input.value = data[input.name];
                if (equals(input.name, 'permission') && data[input.name]) {
                    input.value = input.options.filter(o => {
                        return includes(o.value, map(parseInt, data[input.name]))
                    })
                }
            } else {
                input.value = lookupInputValue(input.name, initialState.inputs)
            }

            if (equals(input.name, 'folders')) {
                input.treeData.nodes = folders;
            }

            return input;
        });

        setGroupState({...groupState, inputs: inputs});
    }, [data, entities, props.show]);

    const handleSubmit = useCallback(values => {
        if (data && props.selectedId) {
            props.update({
                id: props.selectedId,
                data: values,
            });
        } else {
            props.create(values);
        }
        toggle();
    });

    const toggle = _ => {
        setGroupState({...initialState});
        props.close();
    };

    const hideFolders = (hiding: boolean) => {
        const inputs = groupState.inputs.map(i => {
            const input = {...i};
            if (input.name === 'folders') {
                input.hidden = hiding;
            }
            return input;
        });
        setGroupState({...groupState, inputs: inputs});
    };

    const handleOnChange = value => {
        hideFolders(value.name === 'user management admin');
    };

    return (
        <Modal
            isOpen={props.show}
            toggle={toggle}
            className='modal-right modal-content justify-content-start filled-modal'>
            <div className='modal-header'>
                <h4>
                    {props.data ? 'Update ' : 'Create New '}
                    Group
                </h4>
            </div>
            <ModalBody className='flex-fill d-flex pb-0'>
                {loading && <LoaderWidget/>}
                <FormBuilder form={groupState}
                             onSubmit={handleSubmit} close={toggle}
                             children={
                                 (props.data) && (
                                     <div>
                                         <small className={'d-block'}>{t('groups.columns.created_at')}</small>
                                         {formatDate(props.data.created_at)}
                                         <small className={'d-block'}>{t('groups.columns.last_updated')}</small>
                                         {formatDate(props.data.last_updated)}
                                     </div>
                                 )
                             }
                             onChange={handleOnChange}
                />
            </ModalBody>
        </Modal>
    );
};

const mapStateToProps = state => {
    const {entities} = state.Folder;
    return {entities};
};

export default connect(
    mapStateToProps,
    {
        listFolders: folder.actions.list,
        create: group.actions.create,
        update: group.actions.update,
    }
)(withTranslation()(AddGroupComponent));
